import script from "./AssetCategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetCategoryView.vue?vue&type=script&setup=true&lang=js"

import "./AssetCategoryView.vue?vue&type=style&index=0&id=5476a690&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5476a690"]])

export default __exports__